import React from 'react';

export function Button({ onClick, children, className }) {
    return (
        <button
            onClick={onClick}
            className={`px-4 py-2 bg-black/80 text-white rounded-full shadow border border-gray-800 hover:bg-[#121212] hover:border-gray-700 transition backdrop-blur-md min-w-[140px] max-w-[180px] ${className}`}>
            {children}
        </button>
    );
}

